export default function BlueButton({ children, className = "", onClick , brand }) {
  return (
    <button onClick={onClick} className={`rounded-xl px-3 py-2 text-sm font-semibold text-white ${className}`} style={{ backgroundColor: brand.blue }}>{children}</button>
  );
}